document.addEventListener("DOMContentLoaded", function () {
  function moveButtons() {
    const buttons = document.querySelectorAll(".testimonials__slider .flickity-button-holder");
    if (buttons.length > 0) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("flickity-button-wrapper");

      const parent = buttons[0].parentNode;
      parent.insertBefore(wrapper, buttons[0]);
      buttons.forEach((btn) => wrapper.appendChild(btn));
    } else {
      // Safari에서 아직 버튼이 안 만들어졌으면 재시도
      setTimeout(moveButtons, 100);
    }
  }

  setTimeout(moveButtons, 100);
});



document.querySelectorAll(".blog-tabs .tab-link").forEach(link => {
  link.addEventListener("click", e => {
    e.preventDefault();
    const tag = link.dataset.tag;

    // 1️⃣ 모든 li에서 active 제거
    document.querySelectorAll(".blog-tabs .blog__tag").forEach(li => {
      li.classList.remove("active");
    });

    // 2️⃣ 현재 클릭한 li에 active 추가
    link.parentElement.classList.add("active");

    // 3️⃣ 게시물 필터링
    document.querySelectorAll(".blog__post-item").forEach(item => {
      if (tag === "all" || item.dataset.tags.includes(tag)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  });
});